// Enable the submit button!
export function enableSubmitButton($submit = $(".submit")) {
  $submit.prop("disabled", false);
  $submit.removeClass("btn--disabled");
}

// Disable the submit button!
export function disableSubmitButton($submit = $(".submit")) {
  $submit.prop("disabled", true);
  $submit.addClass("btn--disabled");
}
